import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import {
  FaInstagram,
  FaFacebookF,
  FaEnvelope,
  FaYoutube,
  FaLinkedinIn,
} from "react-icons/fa";
import logo from "../../images/logo.png";
export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Top */}
        <div className="footer-top">
          <div className="footer-brand">
            <img src={logo} alt="logo" className="footer-logo" />
         
          </div>

          <div className="footer-socials">
            <a href="https://www.instagram.com/elements.tunisie" aria-label="Instagram"><FaInstagram /></a>
            <a href="https://www.facebook.com/Elementstn" aria-label="Facebook"><FaFacebookF /></a>
            <a href="https://www.instagram.com/elements.tunisie" aria-label="YouTube"><FaYoutube /></a>
            <a href="https://www.linkedin.com/company/elements-tunisie/" aria-label="LinkedIn"><FaLinkedinIn /></a>
             <a href="mailto:Mtr@elements.tn" aria-label="Mail"><FaEnvelope /></a>
          </div>
        </div>

        {/* Middle */}
        <div className="footer-middle">
          <div className="footer-column">
            <h3>Elements Group</h3>
            <ul>
              <li><Link to="/elements/histoire">Histoire & vision du sur-mesure</Link></li>
              <li><Link to="/elements/createurs">Les créateurs & l'équipe</Link></li>
              <li><Link to="#">Nos ateliers, Store & bureaux</Link></li>
              <li><Link to="/elements/partenaires">Partenaires, fournisseurs & marques</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>Collections</h3>
            <ul>
              <li><Link to="/collections/cuisines">Cuisines sur mesure</Link></li>
              <li><Link to="/collections/dressings">Dressings</Link></li>
               <li><Link to="#">Salles de bain</Link></li>
              <li><Link to="#">Aménagement intérieur complet</Link></li>
              <li><Link to="#">Accessoires & solutions de rangement</Link></li>
              <li><Link to="#">Textures & finitions</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>SAV & Garantie</h3>
            <ul>
              <li><Link to="#">Kit de nettoyage</Link></li>
              <li><Link to="/sav/garantie">Garantie</Link></li>
              <li><Link to="/sav/service-apres-vente">Service après-vente</Link></li>
            </ul>
          </div>

          <div className="footer-cta-box">
            <h3>Besoin d’un accompagnement ?</h3>
            <p>
              Prenez rendez-vous avec notre équipe pour découvrir nos produits
              et trouver la meilleure solution pour votre espace.
            </p>
            <a href="/contact" target="__blank" className="footer-cta">
              Prendre rendez-vous
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-links">
            <Link to="/export/projets-international">Projets réalisés à l’international</Link>
            <Link to="#">Témoignages clients</Link>
            <Link to="/export/carte">Carte des réalisations</Link>
            <Link to="/contact">Contacts</Link>
         
          </div>

          <div className="footer-language">
            <span>Langue :</span>
            <button className="active">FR</button>
            <button>EN</button>
          </div>
        </div>

        <div className="footer-copy">
          <p>© 2026 ELEMENTS — Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
}